import React, { useEffect, useState } from "react";
import SelectAudioInput from "./SelectAudioInput";
import SelectAudioOutput from "./SelectAudioOutput";
import SelectVideoInput from "./SelectVideoInput";

import { PAGE_TYPE, setAppPage } from "../../base/app";
import { setIsConnection } from "../../base/connection";
import { setAudioInputDeviceAndUpdateSettings, setVideoInputDeviceAndUpdateSettings, updateDeviceList } from "../../base/devices";
import { i18next, translate } from "../../base/i18n";
import { updateSettings } from "../../base/settings";
import { PreviousButton } from "../../previous-button";

import { useDispatch, useSelector } from "react-redux";
import "../../../assets/css/device.scss";
import { MEDIA_TYPE } from "../../base/media";
import { updateModalState } from "../../base/modal";
import { disposeAndRemoveTracks, getLocalTracks, getTrackState } from "../../base/tracks";
import { DEVICE_SETTING_MODAL_ID } from "../../options";
import { getScreenType, isAndroidDevice } from "../../base/util";

let selectVdoId, selectMicId, isApiSubscribed = true;
function Device({
    t, isRoom
}) {
    const dispatch = useDispatch();
    const tracks = useSelector(state => getLocalTracks(getTrackState(state)));
    
    const [ didMount, setDidMount ] = useState(false);
    const [ selectVdo, setSelectVdo ] = useState(-1);
    const [ selectMic, setSelectMic ] = useState(-1);
    const [ selectVolume, setSelectVolume ] = useState(0);
    const [ entering, setEntering ] = useState(false);
        
    useEffect(() => {
        isApiSubscribed = true;
        APP.UI.showLoading(true);        
        initDevice();
        // APP.mateManagement.initDevice().then(d => {
        //     APP.UI.showLoading(false);
        //     initDevice();
        // });
        
        return (() => {
            APP.mateManagement.removeDeviceListChange();
            isApiSubscribed = false;

            APP.UI.showLoading(false);
            setEntering(false);
        })
    }, []);

    const initDevice = async () => {
        // 현재 사용중인 장치 종료 
        if (isRoom) {
            
            tracks && tracks.map(track => {
                if (!track) return;
                // 이건 
                if (isAndroidDevice()) dispatch(disposeAndRemoveTracks([track.track]));
                
                const id = track.track.deviceId;
                const mediaType = track.mediaType;
                if (mediaType === MEDIA_TYPE.VIDEO) {
                    setSelectVdo(id);
                    window.videoTrackDeviceId = id;
                } else if (mediaType === MEDIA_TYPE.AUDIO) {
                    setSelectMic(id);
                    window.audioTrackDeviceId = id;
                }
            });
        } else {
            const result = await APP.mateManagement.loadDevice();
            if (result && isApiSubscribed) {
                const { tracks, devices } = result;

                devices && dispatch(updateDeviceList(devices));
                // 기본 트랙 가져와 등록 
                tracks && tracks.map(track => {
                    if (!track) return;

                    track.stop();
                    const id = track.getSettings().deviceId;
                    if (track.kind === MEDIA_TYPE.VIDEO) setSelectVdo(id);
                    else if (track.kind === MEDIA_TYPE.AUDIO) setSelectMic(id);
                });
            }
        }
        
        APP.mateManagement.addDeviceListChange(_onDeviceListChange);

        setDidMount(true);
        APP.UI.showLoading(false);
    }
 
    const _onDeviceListChange = async devices => {
        devices && dispatch(updateDeviceList(devices));

        const changeDeviceMic = devices.filter(item => !(selectMicId === 'default' || selectMicId === 'communications') && item.deviceId === selectMicId && item.kind === 'audioinput' );
        const changeDeviceVdo = devices.filter(item => item.deviceId === selectVdoId && item.kind === 'videoinput');

        if (changeDeviceMic.length < 1) setSelectMic(-1);
        if (changeDeviceVdo.length < 1) setSelectVdo(-1);
    };

    useEffect(() => {
        selectMicId = selectMic;
    }, [selectMic]);

    useEffect(() => {
        selectVdoId = selectVdo;
    }, [selectVdo]);

    const onSubmit = async e => {
        if (entering) return;
        setDidMount(false);
        setTimeout(() => { 
            if (isApiSubscribed) setEntering(false);
            updateDeviceSetting();
        }, 1000);
        setEntering(true);
        APP.UI.showLoading(true);
        
        setTimeout(async () => {           
            
            if (!isRoom) {            
                // check API
                const { complete, message } = await APP.API.checkOccupiedUser();
                if ( complete === false ) {
                    alert(message);
                    return;
                } else if (complete === 'duplicate') {
                    const answer = confirm(i18next.t("notify.alertDup"));

                    if (!answer) {
                        dispatch(setAppPage(PAGE_TYPE.LOBBY));
                        return;
                    } else {
                        APP.UI.showLoading(true);
                        const kick_user_id = message.user_uuid;
                        const response = await APP.API.kickOccupiedUser(kick_user_id);

                        if (response.complete) {
                            setTimeout(() => {
                                APP.mateManagement.connection();
                        
                                APP.UI.showLoading(false);
                            }, 2000);

                            return;
                        } else {
                            APP.UI.showLoading(false);
                            alert(response.message);
                            return;
                        }
                    }
                } else if (complete === true) {
                    APP.mateManagement.connection();
                }
            } else {            
                dispatch(updateModalState(DEVICE_SETTING_MODAL_ID));
            } 
        }, 2000);

        
    }

    const updateDeviceSetting = () => {
        dispatch(setVideoInputDeviceAndUpdateSettings(selectVdoId));
        dispatch(setAudioInputDeviceAndUpdateSettings(selectMicId));
        dispatch(updateSettings({ speakerVolume: selectVolume * 0.01 }));
    }

    return (
        <div className={`child`} style={!isRoom ? APP.mateOption.style.deivceBackGround : null}>
            <div className={`device_wrap ${isRoom && "room"} ${!isRoom && 'center'}`}>
                { !isRoom && <div className="option_header">
                    <h3 className="title">{ t("device.connection") }</h3>
                </div> }
                
                <p className="guid">{ t("device.guid") }</p>
                <div className="option_content">
                    <dl className="selected_video">
                        <SelectVideoInput 
                            isRoom={isRoom}
                            didMount={didMount} 
                            cameraId={selectVdo} 
                            setSelectVdo={setSelectVdo}
                        />
                    </dl>

                    <dl className="selected_audio_input">
                        <SelectAudioInput 
                            isRoom={isRoom}
                            didMount={didMount} 
                            micId={selectMic} 
                            setSelectMic={setSelectMic}
                        />
                    </dl>

                    <dl className="selected_audio_output">
                        <SelectAudioOutput isRoom={isRoom} setSelectVolume={setSelectVolume} />
                    </dl>
                </div>
                <div className="option_footer">
                { !isRoom ?
                    <p className="btn btn_large btn_on" onClick={onSubmit} style={{ padding: '4px 28px', fontSize: '20px' }} >{ t("device.enter") }</p>
                    : <p className="btn btn_large btn_on" onClick={onSubmit}> { t("common.okay") } </p> }
                </div> 
            </div>

            { !isRoom && <PreviousButton previousRoute={PAGE_TYPE.NICKNAME} /> }
        </div>
    )
}

export default translate(Device);